export default "__VITE_ASSET__$2VzsgLz__"